import React from 'react';
import { connect } from 'react-redux';

import * as CommonSelectors from 'Pages/managemenu/state/common/selectors';
import { getSearchFilters } from 'Pages/managemenu/state/common/actions';
import { LoadingBase } from 'Components';

import * as RecipeSearchSelectors from './state/selectors';
import {
  searchRecipes,
  setPageSize,
  reset as resetRecipeSearch,
  searchPrepRecipes,
} from './state/actions';

const withRecipesSubscription = Component => {
  class WithRecipeFilters extends React.Component {
    componentDidMount() {
      const { hasFetchedRecipeSubscription, getSearchFilters } = this.props;
      if (!hasFetchedRecipeSubscription) {
        getSearchFilters();
      }
    }

    render() {
      const { hasFetchedRecipeSubscription } = this.props;
      if (!hasFetchedRecipeSubscription) {
        return <LoadingBase />;
      }
      return <Component {...this.props} />;
    }
  }

  const mapStateToProps = state => ({
    hasFetchedRecipeSubscription: CommonSelectors.getHasFetchedRecipeSubscription(
      state
    ),
    mealTypes: CommonSelectors.getMealTypes(state),
    mealTypesMap: CommonSelectors.getMealTypesMap(state),
    mealTypeOptions: CommonSelectors.getMealTypeOptions(state),
    recipeCategories: CommonSelectors.getRecipeCategories(state),
    recipeCategoriesMap: CommonSelectors.getRecipeCategoriesMap(state),
    recipeSources: CommonSelectors.getRecipeSources(state),
    recipeSourcesMap: CommonSelectors.getRecipeSourcesMap(state),
    recipeGroups: CommonSelectors.getRecipeGroups(state),
    recipeGroupsMap: CommonSelectors.getRecipeGroupsMap(state),
    recipeGroupOptions: CommonSelectors.getRecipeGroupOptions(state),
    recipeHACCP: CommonSelectors.getRecipeHACCP(state),
    recipeHACCPMap: CommonSelectors.getRecipeHACCPMap(state),
    recipeServingTemp: CommonSelectors.getRecipeServingTemp(state),
    searchResults: RecipeSearchSelectors.getRecipes(state),
    hasNextPage: RecipeSearchSelectors.getHasNextPage(state),
    loadingRecipes: RecipeSearchSelectors.getLoadingRecipes(state),
    pageSize: RecipeSearchSelectors.getPageSize(state),
  });

  const mapDispatchToProps = {
    getSearchFilters,
    searchRecipes,
    setPageSize,
    resetRecipeSearch,
    searchPrepRecipes,
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(WithRecipeFilters);
};

export { withRecipesSubscription };



// WEBPACK FOOTER //
// ./src/common/Components/RecipeSearch/withRecipesSubscription.js